import script from "./page-layout-cell.vue?vue&type=script&setup=true&lang=js"
export * from "./page-layout-cell.vue?vue&type=script&setup=true&lang=js"

import "./page-layout-cell.vue?vue&type=style&index=0&id=bbfa7e9a&lang=scss"

const __exports__ = script;

export default __exports__